import React, { createContext, useContext, useMemo, useState } from "react";

const ModalCtx = createContext({
    isNewsletterOpen: false,
    openNewsletter: () => {},
    closeNewsletter: () => {},
});

export const ModalProvider = ({ children }) => {
    const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
    const value = useMemo(
        () => ({
            isNewsletterOpen,
            openNewsletter: () => setIsNewsletterOpen(true),
            closeNewsletter: () => setIsNewsletterOpen(false),
        }),
        [isNewsletterOpen],
    );
    return <ModalCtx.Provider value={value}>{children}</ModalCtx.Provider>;
};

export const useNewsletterModal = () => useContext(ModalCtx);
